import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import s from './TFoot.module.scss';

type Props = {
  className?: string;
};

const TFoot: React.FC<PropsWithChildren<Props>> = ({ children, className }) => (
  <tfoot className={classNames(s.sticky, className)}>{children}</tfoot>
);

export default TFoot;
